import { Link } from "react-router-dom";
import { ClipLoader } from "react-spinners";
export function AuctionBidDetailsShimmer({loading=false}) {
  return (
    <>
    {loading && (
       <div className=" bg-white ">
              <div className="hidden lg:block live-auction-list">
                <div className="w-[15.5] flex flex-col pt-[20vh]">
                  <div className="text-[2.6vw] font-semibold text-white">
                    Live Auction
                  </div>
                  <div className="text-white flex gap-3 justify-center text-[1vw] font-urbanist">
                    <Link to="/">
                      <button className="hover:text-white hover:scale-110 duration-150">
                        Home
                      </button>
                    </Link>
                    /
                    <button className="hover:text-white hover:scale-110 duration-150">
                      Live Auction
                    </button>
                  </div>
                </div>
              </div>
            </div>
    )}


      <div className="p-6 bg-gray-50 min-h-screen">
        <div className="flex gap-8 max-w-6xl mx-auto">
          {/* Left Side Box */}
          <div className="flex-1 bg-white rounded-lg p-6 shadow-sm">
            <div className="flex items-start gap-8">
              {/* Left side - Circular Status and Bid Controls */}
              <div className="flex flex-col items-center space-y-6">
                {/* Circular Status */}
                <div className="w-40 h-40 rounded-full border-4 border-gray-300 flex items-center justify-center animate-pulse">
                  <div className="text-center">
                    <div className="h-4 bg-gray-200 rounded w-20 animate-pulse mb-2"></div>
                    <div className="h-4 bg-gray-200 rounded w-16 animate-pulse"></div>
                  </div>
                </div>

                {/* Bid Controls */}
                <div className="flex items-center space-x-4">
                  <div className="w-16 h-10 bg-gray-100 border border-gray-200 rounded animate-pulse flex items-center justify-center">
                    <div className="h-4 bg-gray-200 rounded w-2 animate-pulse"></div>
                  </div>
                  <div className="w-8 h-8 bg-red-100 border border-red-200 rounded-full animate-pulse"></div>
                  <div className="w-8 h-8 bg-red-100 border border-red-200 rounded-full animate-pulse"></div>
                </div>
              </div>

              {/* Right side - Quick Bid Buttons */}
              <div className="flex flex-col space-y-4">
                {/* Header */}
                <div className="flex items-center space-x-2 mb-2">
                  <div className="h-4 bg-gray-200 rounded w-32 animate-pulse"></div>
                  <div className="w-4 h-4 bg-gray-200 rounded-full animate-pulse"></div>
                </div>

                {/* Quick Bid Buttons */}
                <div className="space-y-3">
                  {[1, 2, 3, 4, 5, 6].map((i) => (
                    <div
                      key={i}
                      className="w-48 h-12 bg-cyan-50 border border-cyan-200 rounded-lg animate-pulse flex items-center justify-center"
                    >
                      <div className="h-4 bg-cyan-200 rounded w-16 animate-pulse"></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Right Side Box - Vehicle Details */}
          <div className="flex-1 bg-white rounded-lg p-6 shadow-sm">
            <div className="h-6 bg-gray-200 rounded w-32 animate-pulse mb-6"></div>

            <div className="space-y-4">
              {/* VIN */}
              <div className="flex justify-between items-center py-2 border-b border-gray-100">
                <div className="h-4 bg-gray-200 rounded w-8 animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded w-12 animate-pulse"></div>
              </div>

              {/* Make/Model/Year */}
              <div className="flex justify-between items-center py-2 border-b border-gray-100">
                <div className="h-4 bg-gray-200 rounded w-28 animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded w-28 animate-pulse"></div>
              </div>

              {/* Odometer */}
              <div className="flex justify-between items-center py-2 border-b border-gray-100">
                <div className="h-4 bg-gray-200 rounded w-18 animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded w-24 animate-pulse"></div>
              </div>

              {/* Status */}
              <div className="flex justify-between items-center py-2 border-b border-gray-100">
                <div className="h-4 bg-gray-200 rounded w-12 animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded w-32 animate-pulse"></div>
              </div>

              {/* Transmission */}
              <div className="flex justify-between items-center py-2 border-b border-gray-100">
                <div className="h-4 bg-gray-200 rounded w-24 animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded w-20 animate-pulse"></div>
              </div>

              {/* Title Status */}
              <div className="flex justify-between items-center py-2 border-b border-gray-100">
                <div className="h-4 bg-gray-200 rounded w-20 animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded w-20 animate-pulse"></div>
              </div>

              {/* Zip Code */}
              <div className="flex justify-between items-center py-2 border-b border-gray-100">
                <div className="h-4 bg-gray-200 rounded w-16 animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded w-8 animate-pulse"></div>
              </div>

              {/* Status Code */}
              <div className="flex justify-between items-center py-2 border-b border-gray-100">
                <div className="h-4 bg-gray-200 rounded w-20 animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded w-20 animate-pulse"></div>
              </div>

              {/* Car Location */}
              <div className="flex justify-between items-center py-2 border-b border-gray-100">
                <div className="h-4 bg-gray-200 rounded w-24 animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded w-18 animate-pulse"></div>
              </div>

              {/* Car State */}
              <div className="flex justify-between items-center py-2">
                <div className="h-4 bg-gray-200 rounded w-16 animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded w-26 animate-pulse"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AuctionBidDetailsShimmer;
